import { LiveIntegrationElement, liveIntegrationSchema } from "./schemas/live-integration";
import { createElementId, getUnixTimestampUTC } from "shared/util/utils";
import { DEFAULT_CARD_STACK_HEIGHT, DEFAULT_CARD_STACK_TITLE, DEFAULT_CARD_STACK_WIDTH } from "./card-stack";
import { Point } from "./schemas";

export interface MondayColumnValue {
  id: string;
  value: string;
  type: string;
}

export interface ColumnFilter {
  columnId: string;
  columnValues: string[];
}

export function placeLiveIntegrationStack({ x, y }: Point) {
  const id = createElementId();

  return {
    id,
    item: liveIntegrationSchema.parse({
      type: "liveIntegration",
      x,
      y,
      zIndexLastChangeTime: getUnixTimestampUTC(),
      viewType: "stack",
      filters: [],
      width: DEFAULT_CARD_STACK_WIDTH,
      height: DEFAULT_CARD_STACK_HEIGHT,
      title: DEFAULT_CARD_STACK_TITLE,
    }) as LiveIntegrationElement,
  };
}
